import { useState } from 'react';
import Form, { IChangeEvent } from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';

import { renderBottomSubmitBlock } from 'shared/functions/renderFunctions';

import FieldTemplate from './FieldTemplate';
import ErrorListTemplate from './ErrorListTemplate';
import { widgets } from './constants';
import { getTransformedErrors } from './functions';

type FormCustomFieldsPropsType = {
  jsonSchema: any;
  uiSchema: any;
  customFields: Record<string, any>;
  switchEditMode: (editMode: boolean) => void;
  submitHandler: (data: IChangeEvent<any, any, any>) => void;
};

export const FormCustomFields = ({
  jsonSchema = {},
  uiSchema = {},
  customFields,
  switchEditMode,
  submitHandler,
}: FormCustomFieldsPropsType) => {
  const [fields, setFields] = useState(customFields);
  const transformErrors = (errors: any) => getTransformedErrors(uiSchema, errors);
  const onChange = ({ formData }: IChangeEvent<any, any, any>) => {
    setFields(formData);
  };

  const jsonSchemaKeysLength = Object.keys(jsonSchema).length;

  return (
    <div>
      {!jsonSchemaKeysLength && <div className="padding text-center">{translate('No schema defined')}</div>}
      {!!jsonSchemaKeysLength && (
        <div>
          <Form
            schema={jsonSchema}
            uiSchema={uiSchema}
            formData={fields}
            transformErrors={transformErrors}
            onSubmit={submitHandler}
            validator={validator}
            templates={{ ErrorListTemplate, FieldTemplate }}
            widgets={widgets}
            onChange={onChange}
          >
            <div>{renderBottomSubmitBlock(false, switchEditMode, false)}</div>
          </Form>
        </div>
      )}
    </div>
  );
};
